export default {
  onlineOpen: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000499","开启") /* "开启" */
};
